import request from "../utils/request";

export function getSiteConfigurations() {
    return request({
        url: '/com/site/configurations',
        method: 'get'
    })
}